import React, {useContext, useEffect, useRef, useState} from 'react'
import {useParams} from "react-router";
import Loading from "components/Loading";
import GridBlock from "components/GridBlock";
import {connect} from "react-redux";
import scrollTo from "libs/scrollTo";
import GeneralInfoEntry from "../generalInfo/components/GeneralInfoEntry";
import Tr from 'translations/Translations'
import {ContractorOfferEspdType} from "constants/ContractorOfferEspdType";
import NavigationBar from "components/complex/floatingMenu/NavigationBar";
import {makeStyles} from "@material-ui/core";
import createButton from "components/complex/floatingMenu/createButton";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import CancelIcon from '@material-ui/icons/Cancel';
import {DemandValidationSectionStatus} from "constants/DemandValidationSectionStatus";
import {OfferPositionStatusesReadyToOffering, OfferPositionStatusType} from "../../common/constants/OfferPositionStatusType";
import OfferPositionsSelectPopup, {POPUP_MODE} from "../../common/OfferPositionsSelectPopup";
import useSignature from "hooks/useSignature";
import SignatureIcon from "components/icon/SignatureIcon";
import {StageSectionsUrlParams} from "../../../constants/StageSections";
import {OfferMode} from "../../common/constants/OfferMode";
import OfferSectionContext from "context/OfferSectionContext";
import useLoadingScreen from "hooks/useLoadingScreen";
import {simpleAlert} from "libs/AlertNotification";
import {simpleConfirmNoTranslate} from "libs/ConfirmNotification";
import DemandAdditionalOffersOfferService from "services/DemandAdditionalOffersOfferService";
import AdditionalOfferCommonData from "./components/commonData/AdditionalOfferCommonData";
import OfferPositions from "../offerEdit/components/positions/OfferPositions";
import OfferEspd from "../offerEdit/components/espd/OfferEspd";
import OfferFiles from "../offerEdit/components/files/OfferFiles";
import OfferContractorData from "../../common/contractorData/OfferContractorData";
import PurchaserOfferContext from "context/PurchaserOfferContext";
import EnvelopeOfferDatePopup from "./components/EnvelopeOfferDatePopup";
import {OfferStatusType} from "../../common/constants/OfferStatusType";
import DeleteIcon from "@material-ui/icons/Delete";
import {RoundType} from "constants/RoundType";
import MultiButton, {createButton as createMultiButton} from "components/popup/components/MultiButton";
import SnapshotListPopup, {getConfig} from "../offerEdit/components/SnapshotListPopup";
import HistoryIcon from "@material-ui/icons/History";
import VerificationsPopup, {getVerificationConfig} from "../offerEdit/components/VerificationsPopup";
import useSalesNotification from "hooks/useSalesNotification";
import salesNotificationKeys from "components/popup/salesNotification/constants/salesNotification.keys";
import BoldTypography from "components/BoldTypography";
import useStepperStateCloseValidator from "hooks/useStepperStateCloseValidator";
import {CONTRACTOR_OFFER_EDIT_COMMON_DATA_FORM_ID} from "../offerEdit/components/commonData/OfferCommonData";
import HelpTooltip from "components/HelpTooltip";
import VerificationBeforePlaceOfferPopup, {getVerificationBeforePlaceOfferPopupConfig} from "../offerEdit/components/VerificationBeforePlaceOfferPopup";
import OfferStageTranslationsContext from "context/OfferStageTranslationsContext";
import SupportModeContext from "context/SupportModeContext";

const useStyle = makeStyles(theme => ({
    root: {
        width: '100%'
    },
    floatingMenu: {
        position: 'sticky',
        zIndex: theme.zIndex.appBar - 1,
        bottom: 0,
        marginTop: theme.spacing()
    },
    menuBarPaper: {
        background: theme.palette.background.default,
        border: `solid 1px ${theme.palette.border.dark}`,
    },
    marginLeft: {
        marginLeft: theme.spacing(2)
    }
}))

function AdditionalOfferEditPanel(
    {
        panelRef,
        demandHeader,
        additionalOfferEdit,
        formSubmit,
        formValues,
    }) {

    const classes = useStyle();
    const params = useParams();
    const demandId = params.id;
    const stageId = params.stageId;
    const section = params.section;
    const mode = section === StageSectionsUrlParams.ADDITIONAL_OFFER_EDIT ? OfferMode.EDIT : OfferMode.PLACED;
    const contextSection = useContext(OfferSectionContext);
    const supportMode = useContext(SupportModeContext);
    const stageTr = useContext(OfferStageTranslationsContext);
    const realOnePositionMode = contextSection.onePositionMode || !additionalOfferEdit || additionalOfferEdit.positions.length === 1;
    const purchaserOfferContext = useContext(PurchaserOfferContext)
    const disabled = additionalOfferEdit ? additionalOfferEdit.disabled : true;
    const dataLoading = !additionalOfferEdit || !demandHeader;
    const positionsRef = useRef();
    const {showLoadingScreen, hideLoadingScreen} = useLoadingScreen();
    const [choosePositionPopup, setChoosePositionPopup] = useState(null);
    const [chooseEnvelopeOfferDatePopup, setChooseEnvelopeOfferDatePopup] = useState(null);
    const [chooseSnapshotPopup, setChooseSnapshotPopup] = useState(null);
    const [verifyPopup, setVerifyPopup] = useState(null);
    const [verifyBeforePlacePopup, setVerifyBeforePlacePopup] = useState(null);

    const {doSignDocContent, breakSigning} = useSignature();

    useStepperStateCloseValidator(CONTRACTOR_OFFER_EDIT_COMMON_DATA_FORM_ID, () => {
        return !(additionalOfferEdit.positions.findIndex(x => !!formValues["offerPositionForm_" + x.positionId + "_dirty"]) > -1)
    })

    useEffect(() => {
            if (!dataLoading) {
                setTimeout((elem) => scrollTo(elem), 100, panelRef.current);
            }
        }
        // eslint-disable-next-line
        , [dataLoading])

    useEffect(() => {
        DemandAdditionalOffersOfferService.getOfferEdit(demandId, stageId, mode, purchaserOfferContext?.supplierId);
        return () => {
            DemandAdditionalOffersOfferService.clearResources(DemandAdditionalOffersOfferService.ADDITIONAL_OFFER_EDIT);
        }
        // eslint-disable-next-line
    }, [demandId, stageId, section])


    const placeOffer = () => {
        if (additionalOfferEdit.commonData.status !== DemandValidationSectionStatus.OK) {
            simpleAlert(Tr("fill_missing_data_x", {name: 'contractor_company_data'}, true), false);
            scrollTo(panelRef.current);
        } else {
            const unsavedPos = additionalOfferEdit.positions.find(x => !!formValues["offerPositionForm_" + x.positionId + "_dirty"])
            if (unsavedPos) {
                simpleAlert(Tr("save_form_x", {name: Tr("part_x", {x: unsavedPos.order}) + ": " + unsavedPos.name}), false)
                scrollTo("#offerPositionForm_" + unsavedPos.positionId, 60);
            } else {

                const readyPositions = additionalOfferEdit.positions.filter(x => OfferPositionStatusesReadyToOffering.includes(x.status));
                if (readyPositions.length === 0) {
                    simpleAlert("fill_at_least_one_position");
                    scrollTo(positionsRef.current);
                } else {
                    if (realOnePositionMode) {
                        simpleConfirmNoTranslate(stageTr(!purchaserOfferContext ? "place_offer_confirm" : "place_offer_confirm_operator"), () => submitChoosePositions([readyPositions[0].positionId]))
                    } else {
                        setChoosePositionPopup(purchaserOfferContext ? POPUP_MODE.OPERATOR_PLACE : POPUP_MODE.OFFER);
                    }
                }
            }
        }
    }

    const withdrawOffer = () => {
        if (realOnePositionMode) {
            simpleConfirmNoTranslate(stageTr("withdraw_offer_confirm"), () => submitChoosePositionsWithdraw([additionalOfferEdit.positions[0].positionId]))
        } else {
            setChoosePositionPopup(POPUP_MODE.WITHDRAW);
        }
    }

    const submitChoosePositions = (positionIds) => {
        if (!purchaserOfferContext && contextSection.digitalSign) {
            DemandAdditionalOffersOfferService.verifyBeforePlaceOffer(demandId, stageId, undefined, positionIds).then((resp) => {
                if (resp.success && resp.result.length > 0) {
                    setVerifyBeforePlacePopup(getVerificationBeforePlaceOfferPopupConfig(resp.result, positionIds))
                } else {
                    doSubmitChoosePositions(positionIds)
                }
            }).catch((e) => {
                doSubmitChoosePositions(positionIds);
                console.error(e)
            })

        } else {
            doSubmitChoosePositions(positionIds)
        }
    }
    const doSubmitChoosePositions = (positionIds) => {
        if (!purchaserOfferContext && contextSection.digitalSign) {
            doSignDocContent(
                contextSection.signatureTypes,
                async (sigType) => {
                    const result = await DemandAdditionalOffersOfferService.getDocumentToSign(demandId, stageId, {positionIds, signatureType: sigType});
                    if (!result)
                        breakSigning();
                    return result;

                },
                (signatureType, signature, signatureFileId) => {
                    breakSigning();
                    submitPlaceOffer(positionIds[0], signatureType, signature, signatureFileId)
                },
                (error) => {
                    console.error(error)
                    simpleAlert("signature_error");
                    breakSigning();
                },
                () => {
                    breakSigning();
                },
                async () => contextSection.encryptionEnabled ? contextSection.roundId : null,
            )
        } else {
            submitPlaceOffer(positionIds[0]);
        }
    }

    const submitChoosePositionsWithdraw = (positionIds) => {
        if (contextSection.digitalSign) {
            doSignDocContent(
                contextSection.signatureTypes,
                async (sigType) => {
                    const result = await DemandAdditionalOffersOfferService.getDocumentToWithdraw(demandId, stageId, {positionIds, signatureType: sigType});
                    if (!result)
                        breakSigning();
                    return result;

                },
                (signatureType, signature, signatureFileId) => {
                    breakSigning();
                    submitWithdrawOffer(positionIds, signatureType, signature, signatureFileId)
                },
                (error) => {
                    console.error(error)
                    simpleAlert("signature_error");
                    breakSigning();
                },
                () => {
                    breakSigning();
                },
                async () => {
                    const result = await DemandAdditionalOffersOfferService.requireWithdrawEncryption(demandId, stageId, positionIds);
                    if (!result) {
                        breakSigning();
                    } else if (result.requireEncryption) {
                        return result.roundId;
                    } else {
                        return null;
                    }
                }
            )
        } else {
            submitWithdrawOffer(positionIds);
        }
    }

    const signOffer = () => {
        if (realOnePositionMode) {
            doSignOffer([additionalOfferEdit.positions[0].positionId])
        } else {
            setChoosePositionPopup(POPUP_MODE.OFFER_SIGN);
        }
    }

    const doSignOffer = (positionIds) => {
        doSignDocContent(
            contextSection.signatureTypes,
            async (sigType) => {
                const result = await DemandAdditionalOffersOfferService.getDocumentToSign(demandId, stageId, {
                    positionIds: positionIds,
                    signatureType: sigType
                });
                if (!result)
                    breakSigning();
                return result;

            },
            (signatureType, signature, signatureFileId) => {
                breakSigning();
                showLoadingScreen();
                DemandAdditionalOffersOfferService.signOffer(demandId, stageId, {
                    positions: [{positionId: positionIds[0]}],
                    signatureType,
                    signature,
                    signatureFileId
                }, realOnePositionMode, stageTr).finally(hideLoadingScreen)
            },
            (error) => {
                console.error(error)
                simpleAlert("signature_error");
                breakSigning();
            },
            () => {
                breakSigning();
            },
            async () => contextSection.encryptionEnabled ? contextSection.roundId : null,
        )
    }


    const deleteOffer = () => {
        if (realOnePositionMode) {
            doDeleteOffer([additionalOfferEdit.positions[0].positionId])
        } else {
            setChoosePositionPopup(POPUP_MODE.DELETE_OFFER)
        }

    }

    const doDeleteOffer = (positionId) => {
        simpleConfirmNoTranslate(stageTr("delete_offer_confirm"), () => {
                showLoadingScreen();
                DemandAdditionalOffersOfferService.deleteOffer(demandId, stageId, positionId).finally(hideLoadingScreen)
            }
        )
    }


    const signWithdrawOffer = () => {
        if (realOnePositionMode) {
            doSignWithdrawOffer([additionalOfferEdit.positions[0].positionId])
        } else {
            setChoosePositionPopup(POPUP_MODE.WITHDRAW_SIGN)
        }

    }

    const doSignWithdrawOffer = (positionIds) => {

        doSignDocContent(
            contextSection.signatureTypes,
            async (sigType) => {
                const result = await DemandAdditionalOffersOfferService.getDocumentToWithdraw(demandId, stageId, {
                    positionIds: positionIds,
                    signatureType: sigType
                });
                if (!result)
                    breakSigning();
                return result;

            },
            (signatureType, signature, signatureFileId) => {
                breakSigning();
                showLoadingScreen()
                DemandAdditionalOffersOfferService.signWithdraw(demandId, stageId, {
                    positions: [{positionId: positionIds[0]}],
                    signatureType,
                    signature,
                    signatureFileId
                }, realOnePositionMode, stageTr)
                    .finally(hideLoadingScreen)
            },
            (error) => {
                console.error(error)
                simpleAlert("signature_error");
                breakSigning();
            },
            () => {
                breakSigning();
            },
            async () => {
                const result = await DemandAdditionalOffersOfferService.requireWithdrawEncryption(demandId, stageId, null);
                if (!result) {
                    breakSigning();
                } else if (result.requireEncryption) {
                    return result.roundId;
                } else {
                    return null;
                }
            }
        )
    }


    const submitPlaceOffer = (positionId, signatureType, signature, signatureFileId, envelopeOfferDate) => {

        if (purchaserOfferContext && additionalOfferEdit.envelopeOffer && !envelopeOfferDate) {
            setChooseEnvelopeOfferDatePopup({
                positionId, signatureType, signature, signatureFileId,
                position: additionalOfferEdit.positions.find(x => x.positionId === positionId)
            })
            return;
        }
        showLoadingScreen();
        DemandAdditionalOffersOfferService.placeOffer(demandId, stageId, purchaserOfferContext?.supplierId, realOnePositionMode, {
            positions: [{positionId, envelopeOfferDate}],
            signatureType,
            signature,
            signatureFileId
        }, stageTr).finally(hideLoadingScreen)
    }

    const submitWithdrawOffer = (positionIds, signatureType, signature, signatureFileId) => {
        showLoadingScreen()
        DemandAdditionalOffersOfferService.withdrawOffer(demandId, stageId, {
            positions: positionIds.map(positionId => ({positionId})),
            signatureType,
            signature,
            signatureFileId
        }, realOnePositionMode, stageTr).catch(() => {
        })
            .finally(hideLoadingScreen)
    }


    const stopSigningOperation = (placingOffer) => {
        if (realOnePositionMode) {
            doStopSigningOperation(placingOffer, [additionalOfferEdit.positions[0].positionId])
        } else if (placingOffer) {
            setChoosePositionPopup(POPUP_MODE.OFFER_BREAK);
        } else {
            setChoosePositionPopup(POPUP_MODE.WITHDRAW_BREAK);
        }
    }

    const doStopSigningOperation = (placingOffer, positionId) => {
        simpleConfirmNoTranslate(stageTr(placingOffer ? "sign_offer_form_stop_confirm" : "sign_withdraw_form_stop_confirm"), () => {
                showLoadingScreen();
                DemandAdditionalOffersOfferService.stopSigningOperation(demandId, stageId, positionId).finally(hideLoadingScreen)
            }
        )
    }

    const navigationBarButtons = () => {
        const buttons = [];

        if (!purchaserOfferContext && additionalOfferEdit.positions.findIndex(x => x.contractorOfferStatus === OfferStatusType.NORMAL && x.offerDate === null && x.offerTmpDate !== null) > -1) {
            buttons.push(createButton(stageTr("delete_offer"), deleteOffer, "outlined", DeleteIcon, 'primary', supportMode, false, false));
        }

        if (!purchaserOfferContext && !(additionalOfferEdit.passiveOfferForm && mode === OfferMode.PLACED) && additionalOfferEdit.positions.findIndex(x => x.status === OfferPositionStatusType.PLACED) > -1) {
            buttons.push(createButton(stageTr("withdraw_offer_position"), withdrawOffer, undefined, HighlightOffIcon, 'primary', supportMode, false, false));
        }

        if (!disabled) {
            buttons.push(createButton(stageTr(!purchaserOfferContext ? "place_offer" : "place_offer_operator"), placeOffer, undefined, CheckCircleIcon, 'primary', supportMode, false, false));
        }

        if (additionalOfferEdit.positions.findIndex(x => x.status === OfferPositionStatusType.WAITING_SIGNATURE) > -1) {
            buttons.push(createButton(stageTr("sign_offer_form_stop"), () => stopSigningOperation(true), 'outlined', CancelIcon, undefined, supportMode, false, false));
            buttons.push(createButton(stageTr("sign_offer_form"), signOffer, undefined, SignatureIcon, 'primary', supportMode, false, false));

        }
        if (additionalOfferEdit.positions.findIndex(x => x.status === OfferPositionStatusType.WAITING_WITHDRAW_SIGNATURE) > -1) {
            buttons.push(createButton(stageTr("sign_withdraw_form_stop"), () => stopSigningOperation(false), "outlined", CancelIcon, 'primary', supportMode, false, false));
            buttons.push(createButton(stageTr("sign_withdraw_form"), signWithdrawOffer, undefined, SignatureIcon, 'primary', supportMode, false, false));
        }


        return buttons;
    }

    const successPositionsSelectPopup = (positionIds) => {
        ((mode, posIds) => {
            setChoosePositionPopup(null)
            switch (mode) {
                case POPUP_MODE.OFFER:
                case POPUP_MODE.OPERATOR_PLACE:
                    submitChoosePositions(posIds);
                    break;
                case POPUP_MODE.OFFER_SIGN:
                    doSignOffer(posIds);
                    break;
                case POPUP_MODE.OFFER_BREAK:
                    doStopSigningOperation(true, posIds);
                    break;
                case POPUP_MODE.WITHDRAW:
                    submitChoosePositionsWithdraw(posIds);
                    break;
                case POPUP_MODE.WITHDRAW_SIGN:
                    doSignWithdrawOffer(posIds);
                    break;
                case POPUP_MODE.WITHDRAW_BREAK:
                    doStopSigningOperation(false, posIds);
                    break;
                case POPUP_MODE.DELETE_OFFER:
                    doDeleteOffer(posIds);
                    break;
                default:
                    throw new Error("Unsupported popup mode: " + mode);

            }
        })(choosePositionPopup, positionIds)
    }
    const printVerificationSalesCheck = useSalesNotification(salesNotificationKeys.SIGNATURE_VERIFICATOR, () => setVerifyPopup(getVerificationConfig(demandId, stageId, purchaserOfferContext?.supplierId, RoundType.ADDITIONAL_OFFERS, additionalOfferEdit.positions[0].positionId)));
    const getButtons = () => {
        const buttons = [];
        if (contextSection.additionalOfferAltMode) {
            if (!!purchaserOfferContext && mode === OfferMode.PLACED) {
                buttons.push(createMultiButton(Tr("verify_documents"), printVerificationSalesCheck,
                    undefined, false, undefined, false, SignatureIcon));
            }
            buttons.push(createMultiButton(Tr("change_history"), () => setChooseSnapshotPopup(getConfig(demandId, stageId, purchaserOfferContext?.supplierId, RoundType.ADDITIONAL_OFFERS, additionalOfferEdit.positions[0].positionId)),
                "outlined", false, undefined, false, HistoryIcon));
        }
        return buttons;
    }

    return dataLoading ? <Loading/> : additionalOfferEdit.positions.length > 0 &&
        <div className={classes.root}>
            <GridBlock column>
                <MultiButton buttons={getButtons()}/>

                <GeneralInfoEntry biggerLabel label={Tr('contractor_data')}>
                    <OfferContractorData offerEdit={additionalOfferEdit}/>
                </GeneralInfoEntry>

                <GeneralInfoEntry biggerLabel label={Tr('contractor_company_data')}>
                    <AdditionalOfferCommonData section={contextSection} offerEdit={additionalOfferEdit}/>
                </GeneralInfoEntry>

                {
                    additionalOfferEdit.offerEspdType !== ContractorOfferEspdType.NO &&
                    <GeneralInfoEntry biggerLabel label={Tr('jedz_full')}>
                        <OfferEspd roundType={RoundType.ADDITIONAL_OFFERS} mode={mode} disabled offerEdit={additionalOfferEdit} section={contextSection}/>
                    </GeneralInfoEntry>
                }

                {
                    (!purchaserOfferContext && mode === OfferMode.EDIT) &&
                    <BoldTypography variant="h6" align="center">{Tr("additional_offer_supplier_info")}</BoldTypography>
                }

                <GeneralInfoEntry biggerLabel label={<>
                    {stageTr("offer_documents")}
                    { (additionalOfferEdit.passiveOfferForm || contextSection.digitalSign) && <HelpTooltip className={classes.marginLeft} dangerouslySetTextHTML={Tr("offer_documents_signature_tooltip_html")} />}
                </>}>
                    <OfferFiles roundType={RoundType.ADDITIONAL_OFFERS} mode={mode} disabled={disabled} offerEdit={additionalOfferEdit} section={contextSection} />
                </GeneralInfoEntry>

                {!(additionalOfferEdit.passiveOfferForm && mode === OfferMode.EDIT) &&
                    <OfferPositions roundType={RoundType.ADDITIONAL_OFFERS} positionsRef={positionsRef} offerEdit={additionalOfferEdit} mode={mode}
                                    disabled={disabled}/>
                }

            </GridBlock>
            {
                (!purchaserOfferContext || mode === OfferMode.EDIT) &&
                <div className={classes.floatingMenu}>
                    <NavigationBar buttons={navigationBarButtons()} classesObj={classes}/>
                </div>
            }
            {
                !!choosePositionPopup && <OfferPositionsSelectPopup
                    popupMode={choosePositionPopup}
                    offerEdit={additionalOfferEdit}
                    onCancel={() => setChoosePositionPopup(null)}
                    onSuccess={successPositionsSelectPopup}
                    digitalSign={contextSection.digitalSign}
                    additionalOffers={!contextSection.additionalOfferAltMode}
                />
            }
            {
                !!chooseEnvelopeOfferDatePopup && <EnvelopeOfferDatePopup
                    positions={[chooseEnvelopeOfferDatePopup.position]}
                    onCancel={() => setChooseEnvelopeOfferDatePopup(null)}
                    onSubmit={(values) => {
                        setChooseEnvelopeOfferDatePopup(null);
                        submitPlaceOffer(chooseEnvelopeOfferDatePopup.positionId, chooseEnvelopeOfferDatePopup.signatureType, chooseEnvelopeOfferDatePopup.signature, chooseEnvelopeOfferDatePopup.signatureFileId, values.envelopeOfferDate)
                    }}
                />
            }
            {
                !!chooseSnapshotPopup && <SnapshotListPopup
                    onClose={() => setChooseSnapshotPopup(null)}
                    config={chooseSnapshotPopup}
                />
            }
            {
                !!verifyPopup && <VerificationsPopup
                    onClose={() => setVerifyPopup(null)}
                    config={verifyPopup}
                />
            }
            {
                !!verifyBeforePlacePopup && <VerificationBeforePlaceOfferPopup
                    onCancel={() => setVerifyBeforePlacePopup(null)}
                    onConfirm={(positionIds) => {
                        setVerifyBeforePlacePopup(null);
                        doSubmitChoosePositions(positionIds);
                    }}
                    config={verifyBeforePlacePopup}
                />
            }
        </div>
}

AdditionalOfferEditPanel.propTypes = {}

export default connect((state) => ({
    demandHeader: state.resources.demandHeader,
    additionalOfferEdit: state.resources[DemandAdditionalOffersOfferService.ADDITIONAL_OFFER_EDIT],
    formSubmit: state.form,
    formValues: state.formValues,
}), {})(AdditionalOfferEditPanel);